/**
 * Shared custom event name constants used across navigation components.
 */

// Dispatched by headerbar activator to request sidebar open/close toggle
export const EVENT_SIDEBAR_TOGGLE = "slhuinav:sidebar-toggle";

// Dispatched by sidebar when it closes, so headerbar can restore focus
export const EVENT_SIDEBAR_CLOSED = "slhuinav:sidebar-closed";
